/**
 * Chutt... - PageTransition
 * Wrapper for page-level fade + slide animation
 * Uses CSS @keyframes only (GPU-accelerated, no JS animation lib)
 */
import React from 'react';
import { Box } from '@mui/material';

function PageTransition({ children }) {
  return (
    <Box
      sx={{
        animation: 'pageEnter 0.3s ease-out',
        '@keyframes pageEnter': {
          '0%': { opacity: 0, transform: 'translateY(8px)' },
          '100%': { opacity: 1, transform: 'translateY(0)' },
        },
      }}
    >
      {children}
    </Box>
  );
}

export default PageTransition;
